import { IsOptional, IsString, IsEmail, MaxLength } from 'class-validator'
import { ApiPropertyOptional } from '@nestjs/swagger'

/**
 * DTO pour mettre à jour un utilisateur
 */
export class UpdateUserDto {
  @ApiPropertyOptional({ description: 'Email' })
  @IsOptional()
  @IsEmail()
  email?: string

  @ApiPropertyOptional({ description: 'Username' })
  @IsOptional()
  @IsString()
  @MaxLength(255)
  username?: string

  @ApiPropertyOptional({ description: 'Prénom' })
  @IsOptional()
  @IsString()
  @MaxLength(255)
  firstName?: string

  @ApiPropertyOptional({ description: 'Nom' })
  @IsOptional()
  @IsString()
  @MaxLength(255)
  lastName?: string

  @ApiPropertyOptional({ description: "Nom d'affichage" })
  @IsOptional()
  @IsString()
  @MaxLength(255)
  displayName?: string

  @ApiPropertyOptional({ description: 'Locale (langue)' })
  @IsOptional()
  @IsString()
  @MaxLength(16)
  locale?: string

  @ApiPropertyOptional({ description: 'Timezone' })
  @IsOptional()
  @IsString()
  @MaxLength(64)
  timezone?: string
}
